/**
 * 字典api接口
 * @author： xuyd
 * @date：2022-01-12
 * Copyright (c) 2022 fxwiz all rights reserved.
 */
import request from "@/utils/request.js"

import {dictList, dictTreeList} from "../dictConfig";

import {context} from '@/config/env.js'
const serviceModule = context.sunflower

export default {

  /**
   * 检索dict
   */
  searchDictList: (params) => {
    return request.post(serviceModule + "/dict/searchDictList", params)
  },

  /**
   * 保存dict
   */
  saveDict: (params) => {
    return request.post(serviceModule + "/dict/saveDict", params)
  },

  /**
   * 删除dict
   */
  deleteDict: (id) => {
    return request.post(serviceModule + "/dict/deleteDict?id=" + id)
  },

  /**
   * 刷新全部dict缓存
   */
  refreshDictCache: () => {
    return request.post(serviceModule + "/dict/refreshDictCache")
  },

  /**
   * 下拉查询（批量）
   * @param dictTypes ["sys_yes_no"]
   */
  selectDictBatch: (dictTypes) => {
    return new Promise((resolve) => {
      request.post(serviceModule + "/dict/selectMapDict", dictTypes).then(resp => {
        let data = resp.data;
        let keys = Object.keys(data)
        keys.forEach(k => {
          if(data[k] && data[k].length > 0) {
            dictList[k] = data[k];
          }
        });
        resolve(dictList)
      }).catch(err => {
        resolve(dictList)
      })
    })
  },

  /**
   * 下拉树查询（批量）
   * @param jsonDataList [{dictType, treeLevel}]
   */
  selectDictTreeBatch: (jsonDataList) => {
    return request.post(serviceModule + "/dict/selectMapTreeDict", jsonDataList);
  },

}
